module.exports = __webpack_public_path__ + "images/embed/double_down_arrow.gif";